// extracted by mini-css-extract-plugin
export default {"navbar":"NavBar_navbar__46MCq","navBarCustom":"NavBar_navBarCustom__uxge1","navlogo":"NavBar_navlogo__2oVwZ","text":"NavBar_text__SbH75"};